import { useState } from 'react';
import HeroSection from './components/HeroSection';
import TrendingSection from './components/TrendingSection';
import CategoryNav from './components/CategoryNav';
import LatestSection from './components/LatestSection';
import { getArticlesByCategory } from '@/mocks/articles';
import { siteInfo } from '@/mocks/site';

export default function Home() {
  const [activeCategory, setActiveCategory] = useState('all');
  const filteredArticles = getArticlesByCategory(activeCategory);

  const websiteJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebSite',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    potentialAction: {
      '@type': 'SearchAction',
      target: `${siteInfo.url}/search?q={search_term_string}`,
      'query-input': 'required name=search_term_string',
    },
  };

  const organizationJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'Organization',
    name: siteInfo.name,
    url: siteInfo.url,
    description: siteInfo.description,
    email: siteInfo.email,
    telephone: siteInfo.phone,
    address: {
      '@type': 'PostalAddress',
      addressLocality: '北京',
      addressCountry: 'CN',
    },
    foundingDate: siteInfo.foundingYear,
  };

  const webPageJsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: `${siteInfo.name} - ${siteInfo.tagline}`,
    description: siteInfo.description,
    url: siteInfo.url,
    isPartOf: {
      '@id': `${siteInfo.url}/#website`,
    },
    about: {
      '@id': `${siteInfo.url}/#organization`,
    },
  };

  return (
    <>
      <script type="application/ld+json">{JSON.stringify(websiteJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(organizationJsonLd)}</script>
      <script type="application/ld+json">{JSON.stringify(webPageJsonLd)}</script>
      <HeroSection />
      <TrendingSection />
      <section className="py-10 bg-background-50 border-b border-background-200/70">
        <div className="max-w-[1280px] mx-auto px-4 md:px-6">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-1 h-6 bg-primary-500 rounded-full"></div>
            <h2 className="font-heading text-lg font-bold text-foreground-950 whitespace-nowrap">
              分类浏览
            </h2>
          </div>
          <CategoryNav active={activeCategory} onSelect={setActiveCategory} />
        </div>
      </section>
      <LatestSection articles={filteredArticles} />
    </>
  );
}